import {
  createApolloClient,
  restartWebsockets,
} from "vue-cli-plugin-apollo/graphql-client";
import Vue from "vue";
import VueApollo from "vue-apollo";
import moment from "moment-timezone";

import {
  AUTH_TOKEN,
  clearAuthUser,
  saveAuthUser,
} from "@/app/user-module/helpers/authHelper";

// Install the vue plugin
Vue.use(VueApollo);

// Apollo Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint: process.env.VUE_APP_API,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null, //process.env.VUE_APP_WSS,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  httpLinkOptions: {
    headers: {
      version: process.env.VUE_APP_API_VERSION,
      platform: "EMPLOYEE",
      timezone: moment.tz.guess(),
    },
  },

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
};

export const { apolloClient, wsClient } = createApolloClient({
  ...defaultOptions,
});

apolloClient.wsClient = wsClient;

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  return new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      console.log(
        "%cError",
        "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
        error.message
      );
    },
  });
}

// Manually call this when user log in
export async function onLogin(authUser) {
  saveAuthUser(authUser);
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

  try {
    await apolloClient.resetStore();
  } catch (e) {
    // console.log("vue-apollo.onLogin:resetStore:exception:", e.message);
  }
}

// Manually call this when user log out
export async function onLogout() {
  clearAuthUser();
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

  try {
    await apolloClient.resetStore();
  } catch (e) {
    // console.log("vue-apollo.onLogout:resetStore:exception:", e.message);
  }
}
